import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { UserDetails } from '../pages/admin/models';

export interface UpdateMyProfileRequest {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  phone?: string | null;
}

@Injectable({ providedIn: 'root' })
export class AccountService {
  constructor(private api: ApiService) {}

  getMyProfile() {
    return this.api.get<UserDetails>('/api/account/me');
  }

  updateMyProfile(req: UpdateMyProfileRequest) {
    return this.api.put<void>('/api/account/me', req);
  }
}

